import { ColDef } from "ag-grid-community";

export enum ReasonCode {
    TFWORK = "TFWORK",
    DDT = "DDT",
    BTF = "BTF"
}

export enum OperationScope {
    ViewMdTransportationCartransporterScope = 'SCOPE_VIEW_MDTRANSPORTATION_CARTRANSPORTER_LABEL',
    ViewCsVehicleScope = "SCOPE_CARSHARING_FLEET",
    ViewCsVehicleExportScope = "SCOPE_CARSHARING_EXPORT",
    ViewCsVehicleGenericRedirectScope = "SCOPE_CARSHARING_GENERIC_REDIRECT",
    ViewCsVehicleCustomerbaseScope = "SCOPE_CARSHARING_CUSTOMERBASE",
    CsRedirectVehicleDetail = "SCOPE_VEHICLE_DETAIL_REDIRECT",
    CsLogFileHistory = "SCOPE_LOG_FILE_HISTORY_REDIRECT",
    CsMoveHistory = "SCOPE_MOVE_HISTORY_REDIRECT",
    CsCommandHistory = "SCOPE_COMMAND_HISTORY_REDIRECT",
    CsReportManagement = "SCOPE_REPORTS_MANAGEMENT_REDIRECT",
    CsJiraManagement = "SCOPE_JIRA_MANAGEMENT_REDIRECT",
    CsAlarmsWarning = "SCOPE_ALARMS_WARNINGS_REDIRECT",
    CsCustomerReservations = "SCOPE_CUSTOMER_RESERVATIONS_REDIRECT",
    CsOperatorReservations = "SCOPE_OPERATOR_RESERVATIONS_REDIRECT",
    ViewVehicleETollScope = "SCOPE_VIEW_MDVEHICLE_ETOLLEQUIP",
    UpdateVehicleETollScope = "SCOPE_UPDATE_MDVEHICLE_ETOLLEQUIP",
    ViewVehicleETollImportScope = "SCOPE_VIEW_MDVEHICLE_ETOLLEQUIPIMPORTTRACKING"
}

export const EXPIRED_DEFAULT_COL_DEF: ColDef = {
    resizable: true,
    lockPinned: true,
    unSortIcon: true,
    suppressSizeToFit: true
};

export const DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DATETIME_FORMAT_WITH_OFFSET = "YYYY-MM-DDTHH:mm:ssZ";
export const DEFAULT_TIMEZONE = "Europe/Rome";